import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h2>My Moments</h2>
      <p>Sharing my moments in photos.</p>
    </div>
  )
}

export default Title;